// NPM Imports
import React, { Component } from "react";

// Components Imports
import PipelineSwimlaneCard from "../PipelineSwimLaneCard";
import CreateNewDocCard from "../CreateNewDocCard";
import CreateOrderFormCard from "../CreateOrderFormCard";
import { ReactWindowList } from "../../../commonComponents";

class PipelineSwimlane extends Component {
  shouldComponentUpdate(nextProps) {
    const currentOpportunites = this.props.opportunities.filter(opportunity =>
      this.props.swimlane.status.includes(opportunity.docs.status),
    );
    const previousOpportunities = nextProps.opportunities.filter(
      opportunity => opportunity.docs.status === nextProps.swimlane.status,
    );
    let isNotSame = true;
    if (currentOpportunites.length === previousOpportunities.length) {
      for (let i = 0; i < currentOpportunites.length; i += 1) {
        for (let j = 0; j < previousOpportunities.length; j += 1) {
          if (
            currentOpportunites[i].docs.id === previousOpportunities[j].docs.id
          ) {
            isNotSame = false;
            break;
          }
        }
      }
    }
    return isNotSame;
  }

  _getListComponent = (style, opportunity) => {
    const statusName = this._getStatusName(this.props.swimlane.context);
    // Create extrnal quote card
    if (
      statusName === "draft" &&
      this.props.selectedOpp &&
      opportunity.isExternalQuotes
    ) {
      return (
        <CreateOrderFormCard
          quote={opportunity}
          selectedOpp={this.props.selectedOpp}
          openCreateDocumentPopup={this.props.openCreateDocumentPopup}
        />
      );
    }
    // Document swimelane card
    return (
      <PipelineSwimlaneCard
        swimlane={this.props.swimlane}
        key={opportunity.docs.id}
        opportunity={opportunity}
        openCreateDocumentPopup={this.props.openCreateDocumentPopup}
        confirmDeleteDocument={this.props.confirmDeleteDocument}
        dropdownRef={this.props.dropdownRef}
      />
    );
  };

  _getStatusName = context =>
    context && context.split("_").join("-").toLowerCase();

  render() {
    const { heading, context, subHeading, externalQuotes } =
      this.props.swimlane;
    const { selectedOpp } = this.props;
    const statusName = this._getStatusName(context);
    // Decide the swimelane container height. If the lane
    // status is "draft" then, update the height accordingly.
    let swimeLaneHeight = window.innerHeight - 210;
    if (statusName === "draft") {
      swimeLaneHeight -= 110;
    }
    // Make the opportunities list. If there is an "external_quotes" case &&
    // current user has a write permission then, add the external quotes in
    // opportunites list. (Note :: only for "draft" status case)
    let oppsList = this.props.opportunities;
    const checkCreatePermission =
      this.props.selectedOpp.scope && this.props.selectedOpp.scope.write;
    if (
      checkCreatePermission &&
      statusName === "draft" &&
      selectedOpp &&
      externalQuotes &&
      externalQuotes.length > 0
    ) {
      oppsList = [...externalQuotes, ...this.props.opportunities];
    }
    return (
      <div
        className="pipelineswimlane-column"
        data-test={`pipelineswimlane-column-${statusName}`}>
        <div
          className={`pipelineswimlane-title-wrap ${statusName}`}
          data-test={`pipelineswimlane-title-wrap-${statusName}`}>
          <div
            className="pipelineswimlane-title"
            data-test={`pipelineswimlane-title-${statusName}`}>
            {heading}
          </div>
          <div
            className="pipelineswimlane-subtitle"
            data-test={`pipelineswimlane-subtitle-${statusName}`}>
            {subHeading}
          </div>
          <div className="pipelineswimlane-doc-count">
            <span data-test={`pipelineswimlane-doc-count-${statusName}`}>
              {this.props.opportunities.length}
            </span>
          </div>
        </div>
        {statusName === "draft" && <CreateNewDocCard {...this.props} />}
        <div
          className="pipelineswimlane-documentcard-wrapper"
          data-test={`pipelineswimlane-documentcard-wrapper-${statusName}`}>
          <ReactWindowList
            itemsList={oppsList}
            listContainerClassName="documentcard-reactwindowlist-wrapper"
            listClassName="documentcard-reactwindowlist"
            listContainerHeight={swimeLaneHeight}
            listContainerWidth={310}
            listItemMinHeight={107}
            getListComponent={this._getListComponent}
          />
        </div>
      </div>
    );
  }
}

export default PipelineSwimlane;
